// What is specific to problem kendaraan (the trado one is in problem-kendaraan-trado/utils)
const problemKendaraanConfig = {
  title: "Problem Kendaraan",
  // filter jenis of the problem list
  jenis: "default",

  // columns "#" and "DESKRIPSI" (mobile) that can be sorted, per table (new = last 7 days, old = older)
  sortable: {
    new: { no: false, description: false },
    old: { no: true, description: false },
  },

  // "Lihat Cek": the pages the problem came from
  pengecekanUrl: (pemakaianMobilId) =>
    `/transaksi/cek-keluar-masuk/kembali/${pemakaianMobilId}`,
  auditUrl: (auditKendaraanId) => `/audit/audit-kendaraan/edit/${auditKendaraanId}`,

  // "Group" column: label_grup shown as text
  formatLabelGrup: (labelGrup) => {
    let _labelGrup = labelGrup.replaceAll("_", " ");
    _labelGrup = _labelGrup.charAt(0).toUpperCase() + _labelGrup.slice(1);
    return _labelGrup;
  },
};

export default problemKendaraanConfig;
